<script setup lang="ts">
import { useAuthStore } from '../../stores/auth'
import { useRouter } from 'vue-router'
import { useI18n } from 'vue-i18n'
import { useSidebar } from '../../composables/useSidebar'
import AppIcon from '../ui/AppIcon.vue'
import LanguageSwitcher from './LanguageSwitcher.vue'

const auth = useAuthStore()
const router = useRouter()
const { toggle } = useSidebar()
const { t } = useI18n()

async function logout() {
  await auth.signOut()
  router.push('/')
}
</script>

<template>
  <header class="fixed top-0 left-0 right-0 h-14 glass z-50 flex items-center px-5 gap-6">
    <!-- Mobile hamburger -->
    <button
      aria-label="Toggle navigation menu"
      class="lg:hidden flex items-center justify-center w-8 h-8 rounded text-on-surface-variant hover:bg-surface-container-high transition-colors cursor-pointer"
      @click="toggle"
    >
      <AppIcon name="menu" size="md" />
    </button>

    <!-- Logo -->
    <router-link to="/dashboard" class="flex items-center gap-2.5 shrink-0">
      <div class="w-7 h-7 rounded bg-primary flex items-center justify-center">
        <AppIcon name="swap_horiz" size="sm" class="text-on-primary" />
      </div>
      <span class="text-base font-bold text-on-surface tracking-tight font-display hidden sm:block">Transfer Planner</span>
    </router-link>

    <!-- Spacer -->
    <div class="flex-1" />

    <!-- User section -->
    <div class="flex items-center gap-3">
      <LanguageSwitcher />
      <span class="text-xs text-on-surface-variant hidden md:block truncate max-w-40">{{ auth.user?.email }}</span>
      <button
        @click="logout"
        class="flex items-center gap-1.5 px-3 py-1.5 rounded text-sm font-medium text-on-surface-variant hover:bg-surface-container-high transition-colors cursor-pointer"
      >
        <AppIcon name="logout" size="sm" />
        <span class="hidden sm:inline">{{ t('common.signOut') }}</span>
      </button>
    </div>
  </header>
</template>
